import { ChargeDetailRepoImpl } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepoImpl";
import { ChargeQtyAdjRepoImpl } from "domain/repository/ChargeQtyAdj/ChargeQtyAdjRepoImpl";
import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import { CreditNoteDetailVesselVM } from "presentation/viewModel/CreditNote/CreditNoteDetailVesselVM";
import { useMemo } from "react";

export const useCreditNoteDetailVesselVM = () => {
    const [, setCreditNoteDetailState] = useCreditNoteDetailTracked();
    const creditNoteDetailVesselVM = useMemo(() =>
        CreditNoteDetailVesselVM({
            dispatch: [setCreditNoteDetailState],
            chargeDetailRepo: ChargeDetailRepoImpl(),
            repo: ChargeQtyAdjRepoImpl(),
        }), [setCreditNoteDetailState])

    return creditNoteDetailVesselVM
}